module.exports = __webpack_public_path__ + "media/images/dossier-8615dbc0413fc6315b2509a300812806.svg";